import React, {FC, useEffect, useState} from 'react';

import VisuallyHidden from '../VisuallyHidden';

import {AriaLiveProps} from './AriaLive.types';

const AriaLive: FC<AriaLiveProps> = ({ariaLive = 'polite', timeout = 3000, status}) => {
    const [text, setText] = useState<string>(status);

    useEffect(() => {
        let timer: ReturnType<typeof setTimeout>;
        if (status) {
            setText(status);
            timer = setTimeout(() => {
                setText('');
            }, timeout);
        }
        return () => timer && clearTimeout(timer);
    }, [status, timeout]);

    return (
        <VisuallyHidden aria-live={ariaLive} role={ariaLive === 'assertive' ? 'alert' : 'status'}>
            {text}
        </VisuallyHidden>
    );
};
export default AriaLive;
